module.exports = __webpack_public_path__ + "static/img/ZUCCA_logo.baef275.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project_logo/ZUCCA_logo.png
// module id = MiJo
// module chunks = 0